/**
 * @generated SignedSource<<9242a72a6b39f0ef224a9219d8bb664d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPageHeader_viewer$data = {
  readonly item: {
    readonly localizedPdpUrl: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CheckoutCancelationPolicy_item">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutHeaderBanner_viewer">;
  readonly " $fragmentType": "CheckoutPageHeader_viewer";
};
export type CheckoutPageHeader_viewer$key = {
  readonly " $data"?: CheckoutPageHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPageHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPageHeader_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Literal",
          "name": "pageType",
          "value": "CHECKOUT"
        }
      ],
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutCancelationPolicy_item"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localizedPdpUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutHeaderBanner_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d52dc73ccb49a43dd7a976900257150b";

export default node;
